var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndonesiaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "layout_icon__1cBt5 layout_iconShadow__1_5UW",
    width: 20,
    viewBox: "0 0 20 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e70011",
    fillRule: "evenodd",
    className: "a",
    d: "M0,0H20V7.781H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    className: "b",
    d: "M0,240H20v7.5H0Z",
    transform: "translate(0 -232.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndonesiaFlag);
export default __webpack_public_path__ + "static/media/indonesiaFlag.b350925eb2b785a621ed17c34ac9b7a2.svg";
export { ForwardRef as ReactComponent };